import { AIStaffLevel, AIStaffRole, HiringStage } from "@/lib/types";

export const staffStages: HiringStage[] = [
  { 
    id: "1", 
    title: "Select Assistant", 
    description: "Choose your AI Assistant", 
    isCompleted: false, 
    order: 0 
  },
  { 
    id: "2", 
    title: "Review Capabilities", 
    description: "Learn what this AI assistant can do", 
    isCompleted: false, 
    order: 1 
  },
  { 
    id: "3", 
    title: "Onboarding", 
    description: "Get your AI assistant set up with your business", 
    isCompleted: false, 
    order: 2 
  }
];

export const aiCandidates = [
  {
    id: 1,
    name: "Marketing Assistant",
    avatar: "📊",
    role: "marketing" as AIStaffRole,
    description: "Creates social media posts, email campaigns, and content strategies to grow your business",
    skills: ["Content Creation", "Social Media", "Email Marketing", "Analytics"],
    benefits: "Increase brand awareness and generate more leads through consistent marketing"
  },
  {
    id: 2,
    name: "Data Entry Assistant",
    avatar: "📋",
    role: "data-entry" as AIStaffRole,
    description: "Organizes information, manages spreadsheets, and keeps your business data up-to-date",
    skills: ["Data Organization", "Spreadsheets", "Record Keeping", "Document Processing"],
    benefits: "Save hours of manual work and reduce errors in your business data"
  },
  {
    id: 3,
    name: "Customer Support Assistant",
    avatar: "🎧",
    role: "customer-support" as AIStaffRole,
    description: "Answers customer questions, resolves support tickets, and improves customer satisfaction",
    skills: ["Ticket Resolution", "Customer Communication", "FAQ Management", "Support Analytics"],
    benefits: "Provide faster customer service and increase customer satisfaction"
  },
  {
    id: 4,
    name: "Sales Assistant",
    avatar: "💼",
    role: "sales" as AIStaffRole,
    description: "Handles lead qualification, follow-ups, and provides sales analytics to boost revenue",
    skills: ["Lead Management", "Follow-up Automation", "Sales Analytics", "Pipeline Management"],
    benefits: "Convert more leads into customers and increase your sales efficiency"
  },
  {
    id: 5,
    name: "Project Management Assistant",
    avatar: "📅",
    role: "project-management" as AIStaffRole,
    description: "Helps organize tasks, timelines, and project reporting for your team",
    skills: ["Task Management", "Timeline Planning", "Progress Tracking", "Resource Allocation"],
    benefits: "Keep your projects on track and improve team coordination"
  }
];

export const roleCapabilities = {
  "marketing": [
    "Create engaging social media posts for multiple platforms",
    "Design email marketing campaigns that convert",
    "Develop content calendars and marketing strategies",
    "Track performance metrics and provide analytics reports",
    "Generate blog posts and website content optimized for SEO"
  ],
  "data-entry": [
    "Organize and maintain spreadsheets and databases",
    "Process and validate data to ensure accuracy",
    "Create reports and visualizations from your data",
    "Automate repetitive data entry tasks",
    "Extract information from various document formats"
  ],
  "customer-support": [
    "Answer common customer questions instantly",
    "Manage and prioritize support tickets",
    "Create knowledge base articles and FAQs",
    "Provide 24/7 initial response to customer inquiries",
    "Analyze customer feedback for improvement opportunities"
  ],
  "sales": [
    "Qualify leads based on your criteria",
    "Automate follow-up emails and communications",
    "Track sales metrics and generate performance reports",
    "Manage your sales pipeline and forecast revenue",
    "Create personalized sales outreach messages"
  ],
  "project-management": [
    "Organize and prioritize tasks for your team",
    "Create and manage project timelines",
    "Generate progress reports and analytics",
    "Allocate resources efficiently",
    "Track milestones and deadlines"
  ]
};
